<section class="chronos-dialog--size-lg">
  <div class="p-grid p-nogutter kpi">
    <div class="kpi__container">
      <div class="kpi__container-values" *ngIf="periodicQaCheck">
        <lib-pallet-kpi
          class="kpi__item"
          [kpiLabel]="'RUN_PHASE.FREQUENCY_TYPE' | translate"
          [kpiValue]="formatFrequencyType(periodicQaCheck.frequencyType) | translate"
          [compact]="true"
          [emphasizeText]="true"
          [leftAligned]="true"
        ></lib-pallet-kpi>
        <lib-pallet-kpi
          class="kpi__item"
          [kpiLabel]="'RUN_PHASE.FREQUENCY' | translate"
          [kpiValue]="'RUN_PHASE.MANUAL' | translate"
          [compact]="true"
          [emphasizeText]="true"
          [leftAligned]="true"
        ></lib-pallet-kpi>
        <lib-pallet-kpi
          class="kpi__item"
          [kpiLabel]="'RUN_PHASE.TIME_STAMP' | translate"
          [kpiValue]="periodicQaCheck.creationTime ? (periodicQaCheck.creationTime | utcToLocalDate : 'dddd, D MMMM y, HH:mm') : ''"
          [compact]="true"
          [emphasizeText]="true"
          [leftAligned]="true"
        ></lib-pallet-kpi>
      </div>
    </div>
  </div>
  <app-qa-check-list-in-run
    *ngIf="periodicQaCheck"
    [fields]="periodicQaCheck.productionQaChecks"
    (formValidationChange)="setConfirmButtonStatus($event)"
    [isManualPeriodicQaCheck]="true"
    [isAutomaticPeriodicQaCheck]="false"
    [signatureConfig]="signatureConfig"
  ></app-qa-check-list-in-run>

  <div *ngIf="periodicQaCheck">
    <app-signature
      *ngIf="isSignatureEnabled"
      [productionQaCheck]="periodicQaCheck.productionQaChecks"
      [keepBorder]="true"
      [signatureConfig]="signatureConfig"
    ></app-signature>
  </div>

  <lib-modal-footer
    [submitLabel]="'PALLET_CARD.QA_CONFIRM'"
    (submitClicked)="submitModal()"
    [submitDisabled]="!isConfirmButtonEnabled"
    [showDeclineButton]="false"
  ></lib-modal-footer>
</section>
